/* gl-matrix/esm/index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    const glMatrix = (0, tslib_1.__importStar)(require("68ca94c15c") /* ./common.js */);
    exports.glMatrix = glMatrix;
    const mat2 = (0, tslib_1.__importStar)(require("7c0b8e6048") /* ./mat2.js */);
    exports.mat2 = mat2;
    const mat2d = (0, tslib_1.__importStar)(require("dc03f0a621") /* ./mat2d.js */);
    exports.mat2d = mat2d;
    const mat3 = (0, tslib_1.__importStar)(require("0285c50a7e") /* ./mat3.js */);
    exports.mat3 = mat3;
    const mat4 = (0, tslib_1.__importStar)(require("a427635f32") /* ./mat4.js */);
    exports.mat4 = mat4;
    const quat = (0, tslib_1.__importStar)(require("eb06fc032a") /* ./quat.js */);
    exports.quat = quat;
    const quat2 = (0, tslib_1.__importStar)(require("277615c682") /* ./quat2.js */);
    exports.quat2 = quat2;
    const vec2 = (0, tslib_1.__importStar)(require("c56d9ff837") /* ./vec2.js */);
    exports.vec2 = vec2;
    const vec3 = (0, tslib_1.__importStar)(require("2c5eb22089") /* ./vec3.js */);
    exports.vec3 = vec3;
    const vec4 = (0, tslib_1.__importStar)(require("c1aa33d719") /* ./vec4.js */);
    exports.vec4 = vec4;
}
